module.exports = __webpack_public_path__ + "static/media/LCD_5.42d73794.svg";